export const countAcceptedWritersOffers = (orderId, writersOffers) => {
  return writersOffers
    .filter(
      (offer) => offer.orderId === orderId && parseInt(offer.isAccepted) === 3
    )
    .reduce((a, b) => parseInt(a) + (parseInt(b['textAmount']) || 0), 0);
};
